import LoadingBox from './LoadingBox'

export default LoadingBox
